import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { MessageBubble } from './MessageBubble'

import styles from './ChatMessage.module.scss'

interface UserMessageBubbleProps {
  message: AgentChatMessage
}

export const UserMessageBubble: React.FC<UserMessageBubbleProps> = ({
  message,
}) => (
  <MessageBubble sender="user">
    {message.content}
    <div className={styles.messageTimestamp}>{message.timestamp}</div>
  </MessageBubble>
)

export default UserMessageBubble
